import i18next from 'app/translations/i18n';

/**
 * Aplica las traducciones a los tipos de contenido
 * @param {Array} types - Array de tipos de contenido
 * @returns {Array} - Array de tipos con las traducciones aplicadas
 */
export function translateTypes(types) {
  if (!types || !Array.isArray(types)) {
    return types;
  }

  return types.map((type) => {
    // Buscar la traducción para este tipo
    const name = i18next.t(`contents-types:${type.guid}`, { defaultValue: type.name });

    return { ...type, name };
  });
}

/**
 * Aplica las traducciones a un tipo específico
 * @param {Object} type - Tipo de contenido
 * @returns {Object} - Tipo con la traducción aplicada
 */
export function translateType(type) {
  if (!type || !type.guid) {
    return type;
  }

  const name = i18next.t(`contents-types:${type.guid}`, { defaultValue: type.name });

  return { ...type, name };
}
